module.exports = "/* MessagesComponent's private CSS styles */\n"